<template>
    <div class="tr" :class="{ 'tr--expanded': showMore }" v-if="data">
        <div class="tr__upper">
            <div class="tr__actions">
                <a-icon
                    @click.native="showMore = !showMore"
                    icon="Dropdown"
                    style="cursor: pointer"
                />
            </div>
            <div class="tr__primary">
                <div class="tr-featured">
                    <div class="tr-featured__image c-fig c-fig--promos">
                        <img
                            v-if="data.logo"
                            :src="data.logo.urls.medium"
                            class="c-fig__img"
                        />
                    </div>
                    <div class="tr-featured__details">
                        <p class="typo typo--name">{{ data.name }}</p>
                        <p class="typo typo--secondary">{{ promoType }}</p>
                        <p class="typo typo--secondary">
                            Od
                            <time datetime>{{ startAt }}</time>
                            do
                            <time datetime>{{ finishAt }}</time>
                        </p>
                    </div>
                </div>
            </div>

            <div class="tr__secondary">
                <div
                    class="tr-brand"
                    :style="
                        `background-image: url(${data.company.logo.urls.small})`
                    "
                ></div>
            </div>
            <div class="tr__tertiary">
                <div class="tr-data is-column">
                    <div class="tr-data__cell">
                        <span class="tr-data__dt">Liczba produktów</span>
                        <span class="tr-data__dd">{{
                            Object.keys(data.labels).length
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="tr__drawer is-expandable" v-if="showMore">
            <h6 class="typo--headline">Szczegóły</h6>
            <div
                class="
                    mp-promos__data
                    tr-data
                    is-column is-lg-row
                    row-cols-lg-4
                "
            >
                <div class="tr-data__cell">
                    <span class="tr-data__dt">Czas trwania promocji</span>
                    <span class="tr-data__dd">{{
                        durationDays | plurals('dzień', 'dni')
                    }}</span>
                </div>
                <div class="tr-data__cell">
                    <span class="tr-data__dt">{{ daysLeft.countText }}</span>
                    <span class="tr-data__dd">{{ daysLeft.diff }}</span>
                </div>
                <div class="tr-data__cell">
                    <span class="tr-data__dt">Limit użyć na paragonie</span>
                    <span class="tr-data__dd">{{
                        data.usage_limit_per_receipt
                            ? data.usage_limit_per_receipt
                            : '-'
                    }}</span>
                </div>
                <div class="tr-data__cell">
                    <span class="tr-data__dt">Tekst na paragonie</span>
                    <span
                        v-if="data.discount_text"
                        @click.stop.prevent
                        class="tr-data__dd"
                        v-tooltip="data.discount_text"
                        >pokaż</span
                    >
                    <a v-else class="tr-data__dd">-</a>
                </div>
            </div>
            <h6 class="typo--headline" v-if="productTriggers.length > 0">
                Wyzwalacze
            </h6>
            <div v-if="productTriggers.length > 0" class="mb-5">
                <promotion-preview-product
                    v-for="(product, idx) in productTriggers"
                    :key="idx"
                    :product="product"
                    :showMaxPrice="false"
                />
            </div>
            <div>
                <div
                    class="tr mp-promos__product"
                    v-for="(product, productId, idx) in data.labels"
                    :key="idx"
                >
                    <div class="tr__upper mp-labels__products">
                        <div class="tr__primary">
                            <!-- <div class="tr-featured">
                                <div class="tr-featured__image tr-featured__image--product">
                                    <img :src="product.image.urls.small" alt class="img-fluid" />
                                </div>
                                <div class="tr-featured__details">
                                    <span class="typo typo--label">EAN: {{ product.ean }}</span>
                                    <p class="typo typo--name">{{ product.name }}</p>
                                </div>
                            </div>-->
                            <div class="tr-featured">
                                <div class="c-fig c-fig--promos">
                                    <img
                                        class="c-fig__img"
                                        :src="product.image.urls.small"
                                        alt
                                    />
                                </div>
                                <div class="tr-featured__details">
                                    <span class="typo typo--label"
                                        >EAN: {{ product.ean }}</span
                                    >
                                    <p class="typo typo--name">
                                        {{ product.name }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="tr__secondary tr-data is-column">
                            <div class="tr-data__cell mp-labels-form__legend">
                                <div class="tr-data__dt">Grupa cenowa</div>
                                <div class="tr-data__dd">
                                    <span class="mp-labels-form__input1">Cena poza promocją</span>
                                    <span class="mp-labels-form__input2">Liczba kopii</span>
                                </div>
                            </div>

                            <label-group
                                v-for="(group, groupId, idxx) in product.group"
                                :group="group"
                                :product="product"
                                :productId="+productId"
                                :subscriptionIds="product.subscriptions"
                                :id="productId + idxx"
                                :sum="product.sum"
                                :key="idxx"
                            />
                        </div>-->
                    </div>
                </div>
            </div>
        </div>
        <div
            class="
                tr__checkbox
                custom-control custom-checkbox custom-checkbox-lg
            "
        >
            <ui-checkbox-input
                :name="'c-promos-' + data.id"
                v-model="selectLabel"
            />
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import PromotionPreviewProduct from '@/components/promotions/PromotionPreviewProduct'
// import LabelGroup from '@/components/labels/LabelGroup'

export default {
    data() {
        return {
            showMore: false,
            checked: false
        }
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        promoTypes: {
            type: Object,
            required: false
        },
        previewType: {
            type: String,
            required: true
        },
        setWeight: {
            type: String,
            required: false
        }
    },
    components: {
        PromotionPreviewProduct
        // LabelGroup
    },
    computed: {
        startAt() {
            return moment(this.data.start_at).format('DD-MM-YYYY, HH:mm')
        },
        finishAt() {
            return moment(this.data.finish_at).format('DD-MM-YYYY, HH:mm')
        },
        products() {
            let products = []
            if (this.data.products.length > 0) {
                products = this.data.products.filter(el => el.promotional)
            }
            return products
        },
        productTriggers() {
            if (this.data.products.length > 0) {
                return this.data.products.filter(el => !el.promotional)
            } else {
                return []
            }
        },
        durationDays() {
            const start = moment(this.data.start_at)
            const end = moment(this.data.finish_at)
            return end.diff(start, 'days')
        },
        daysLeft() {
            return this.$store.getters.getDaysLeft(this.data)
        },
        selectLabel: {
            get() {
                return this.$store.getters.getSelectedLabelBoolean(this.data.id)
            },
            set(value) {
                this.$store.dispatch('selectLabel', {
                    id: this.data.id,
                    value
                })
                if (value === false) {
                    this.$store.dispatch('setSelectAllPromotions', false)
                }
            }
        },
        promoType() {
            return this.$store.getters.getPromoTypeByValue(this.data.type)
        }
    }
}
</script>
